import { render, staticRenderFns } from "./NotebookItem.vue?vue&type=template&id=f95350bc&scoped=true"
import script from "./NotebookItem.vue?vue&type=script&lang=ts"
export * from "./NotebookItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f95350bc",
  null
  
)

export default component.exports